import WRAP from "WRAP-JS";
import LegendFix from "../legend/LegendFix";
import {
  configFixDh,
  configFixLayer
} from "./config/ConfigFix";
import { MAP_ID_FIX } from "../../../store/MapContentsState";

class Fix {
  static NAME = MAP_ID_FIX
  static FIX_NAME = Fix.makeContentsKey('FIX');
  static FIXN_NAME = Fix.makeContentsKey('FIXN');
  static RNAV_NAME = Fix.makeContentsKey('RNAV');

  contentsVisibleState = {
    [Fix.FIX_NAME]: true,
    [Fix.FIXN_NAME]: true,
    [Fix.RNAV_NAME]: true,
  };

  dhFix;
  layerFix;
  ready = false;

  constructor() {
    this.layerFix = new WRAP.Geo.Layer(Fix.FIX_NAME);
    this.layerFix.setVisible(false);
  }

  initialize() {
    this.initData();
    this.initLayer();
    this.ready = true;
  }

  initData() {

    this.dhFix = new WRAP.Data(configFixDh);

  }

  initLayer() {
    this.layerFix.configure(this.dhFix, configFixLayer);

    this.layerFix.setAttributes({
      filter: this._visibleFilter.bind(this)
    });
    
    const displayToolTip = (geo) => {
      return geo.properties.ident;
    };
    this.layerFix.setTooltip(displayToolTip);
  }

  async drawLayer(visible) {
    if (!this.dhFix) {
      this.initialize();
    }
    this.setVisible(visible);
  }

  getLayer() {
    return [this.layerFix];
  }

  setVisible(visible, contents) {
    if (contents) {
      this.contentsVisibleState[contents] = visible;
      this.layerFix.invalidate();
    } else {
      if (visible) {
        this.layerFix.show();
      } else {
        this.layerFix.hide();
      }
    }
  }

  getLegend() {
    return {
      id: Fix.NAME,
      label: 'FIX',
      component: LegendFix,
      contents: this
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  _visibleFilter(feature) {
    return this.contentsVisibleState[ Fix.makeContentsKey(feature.properties.kind) ];
  }

  static makeContentsKey(kind) {
    return `${Fix.NAME}_${kind}`;
  }
}

export default Fix;